module.exports = __webpack_public_path__ + "static/img/w_12_m.2f5bcac1.jpg";